import React from "react";
import "./Table.scss";
import { useIntl } from "react-intl";

const Table = ({ className, headers, shouldHighlight, onClick }) => {
	const { formatMessage } = useIntl();

	return (
		<div className={`table  ${className ? className : ""}`}>
			<div className={`table-header flex direction-row align-items-center justify-content-between `}>
				{headers.map((header) => {
					return (
						<div
							className={`text text-body--4 text-bold ${shouldHighlight ? "hover-effect" : ""}`}
							style={{ width: `${100 / headers.length}%` }}
							onClick={() => {
								if (onClick) {
									onClick(header);
								}
							}}
						>
							{formatMessage({ id: `${header}` })}
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default Table;
